import { ViewService } from '@weave/schema-gen-ts/dist/schemas/payments/views/service/service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaView1Service = bindHTTP(ViewService);
export const serviceName = 'view1' as const;
